import { EMBED_CAPABLE_PRODUCTS } from './constants';
import type { KnowledgeCardSource } from './types';

/**
 * Extracts the hostname from a URL string.
 * Returns undefined if the URL is invalid.
 */
export const extractUrlHostname = (sourceUrl: string): string | undefined => {
	let url;
	try {
		url = new URL(sourceUrl);
	} catch {
		return undefined;
	}
	return url.hostname;
};

/**
 * Check if a URL belongs to an embed-capable product based on its domain.
 */
export function isEmbedCapableUrl(url: string): boolean {
	if (!url) {
		return false;
	}
	const hostname = extractUrlHostname(url);
	if (!hostname) {
		return false;
	}
	return EMBED_CAPABLE_PRODUCTS.some(({ urlPatterns }) =>
		urlPatterns.some((pattern) => hostname === pattern || hostname.endsWith(`.${pattern}`)),
	);
}

/**
 * Appends search_id to the source URL for Confluence sources so that
 * search session context is preserved for analytics tracking.
 */
export function constructSourceUrl({
	source,
	searchSessionId,
}: {
	searchSessionId: string;
	source: KnowledgeCardSource;
}): string {
	if (source.product === 'Confluence' && !!searchSessionId) {
		const url = new URL(source.url);
		url.searchParams.append('search_id', searchSessionId);
		return url.toString();
	}
	return source.url;
}
